/*
 * Lists
 */
export const exploreRecsThreadId = 'explore:recs';
export const exploreReviewsThreadId = 'explore:reviews';
export const exploreRecentColsThreadId = 'explore:recentCollections';
export const exploreFeaturedColsThreadId = 'explore:featuredCollections';
